// @flow
import * as schoolsActions from 'redux/schools/actions'
import * as districtsActions from 'redux/districts/actions'
import * as flyersActions from 'redux/flyers/actions'

const { fetchOneDistrict } = districtsActions
const { fetchOneSchool } = schoolsActions
const { fetchDistrictFlyers } = flyersActions

const REQUEST_DISTRICT_FLYERS_AND_SCHOOLS_FOR_SCHOOL =
  'REQUEST_DISTRICT_FLYERS_AND_SCHOOLS_FOR_SCHOOL'
const REQUEST_DISTRICT_FLYERS_AND_SCHOOLS =
  'REQUEST_DISTRICT_FLYERS_AND_SCHOOLS'
const RECEIVE_ERROR = 'flyerGrid/RECEIVE_ERROR'
const SET_CATEGORY_FILTER = 'SET_CATEGORY_FILTER'
const SET_FLYER_FILTER = 'SET_FLYER_FILTER'

// Action Types
type ReceiveErrorAction = {
  type: 'flyerGrid/RECEIVE_ERROR',
  schoolId: ?string,
  error: ?any // string error or Error type?
}

type SetCategoryFilterAction = {
  type: 'SET_CATEGORY_FILTER',
  category: ?string
}

type SetFlyerSortAction = {
  type: 'SET_FLYER_SORT',
  sort: ?string
}

type SetFlyerFilterAction = {
  type: 'SET_FLYER_FILTER',
  flyerId: ?string
}

type RequestDistrictFlyersAndSchoolsForSchoolAction = {
  type: 'REQUEST_DISTRICT_FLYERS_AND_SCHOOLS_FOR_SCHOOL',
  schoolId: ?string
}

type RequestDistrictFlyersAndSchools = {
  type: 'REQUEST_DISTRICT_FLYERS_AND_SCHOOLS',
  districtId: ?string
}

type FlyerGridAction =
  | ReceiveErrorAction
  | SetCategoryFilterAction
  | SetFlyerSortAction
  | SetFlyerFilterAction
  | RequestDistrictFlyersAndSchoolsForSchoolAction
  | RequestDistrictFlyersAndSchools

// Action Creators
const receiveError = (error: ?any, schoolId: ?string): ReceiveErrorAction => ({
  type: RECEIVE_ERROR,
  schoolId,
  error
})

export const setCategoryFilter = (
  category: ?string
): SetCategoryFilterAction => ({
  type: SET_CATEGORY_FILTER,
  category
})

export const setFlyerFilter = (flyerId: ?string): SetFlyerFilterAction => ({
  type: SET_FLYER_FILTER,
  flyerId
})

const requestDistrictFlyersAndSchoolsForSchool = (
  schoolId: ?string
): RequestDistrictFlyersAndSchoolsForSchoolAction => ({
  type: REQUEST_DISTRICT_FLYERS_AND_SCHOOLS_FOR_SCHOOL,
  schoolId
})

const requestDistrictFlyersAndSchools = (
  districtId: ?string
): RequestDistrictFlyersAndSchools => ({
  type: REQUEST_DISTRICT_FLYERS_AND_SCHOOLS,
  districtId
})

export const fetchDistrictFlyersAndSchools = (
  districtId: ?string
) => dispatch => {
  dispatch(requestDistrictFlyersAndSchools(districtId))
  dispatch(fetchOneDistrict(districtId))
  return dispatch(fetchDistrictFlyers(districtId))
}

export const fetchDistrictFlyersAndSchoolsForSchool = (schoolId: ?string) => (
  dispatch,
  getState
) => {
  dispatch(requestDistrictFlyersAndSchoolsForSchool(schoolId))
  return dispatch(fetchOneSchool(schoolId))
    .then(() => {
      // FIXME!: fix whack schools.school state
      const districtId = getState().schools[schoolId].district_id
      return dispatch(fetchDistrictFlyersAndSchools(districtId))
    })
    .catch(err => dispatch(receiveError(err, schoolId)))
}

type InitialFlyerGridState = {
  flyerFilter: ?string,
  categoryFilter: string,
  error: ?any // TODO: type alias error object, or only handle string in state
}

const initialState = {
  flyerFilter: null,
  categoryFilter: 'All',
  error: null
}

export const reducer = (
  state: InitialFlyerGridState = initialState,
  action: FlyerGridAction
) => {
  switch (action.type) {
    case REQUEST_DISTRICT_FLYERS_AND_SCHOOLS_FOR_SCHOOL:
    case REQUEST_DISTRICT_FLYERS_AND_SCHOOLS: {
      return {
        ...state,
        error: null
      }
    }
    case RECEIVE_ERROR: {
      return {
        ...state,
        error: action.error
      }
    }
    case SET_FLYER_FILTER: {
      return {
        ...state,
        flyerFilter: action.flyerId
      }
    }
    case SET_CATEGORY_FILTER: {
      return {
        ...state,
        categoryFilter: action.category
      }
    }
    default:
      // (action: empty)
      return state
  }
}

export default {
  reducer,
  actions: { setFlyerFilter }
}



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/redux.js